import React from 'react';
import PropTypes from 'prop-types';
import UsersTable from './UsersTable';

export default function MaintainUsers(props) {
  const { companyId, customerTypeId } = props;

  return (
    <div className="setting-header">
      <UsersTable companyId={companyId} customerTypeId={customerTypeId} />
    </div>
  );
}
MaintainUsers.propTypes = {
  companyId: PropTypes.string,
  customerTypeId: PropTypes.number,
};
